import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LeftSidebar from "./LeftSidebar";
import TopHeader from "./TopHeader";
import SEO from "../Seo";
import { scAxiosAdmin, thirdparty } from "../..";
import { IMAGE_URL } from "../../constants";
const Banner_create = (props) => {
    const [data, setData] = useState([]);
    console.log(data, "data");
    const [formData, setFormData] = useState({
        type: "home_page",
        title: "",
        description: "",
        image: null,
        status: 1,
        index_no: 1
    });
    console.log(formData, "hello");

    const fetchData = async () => {
        try {
            const response = await thirdparty.get(
                `/banner/${props.match.params.id}`
            );
            console.log("response_data: ", response.data);
            setFormData({
                ...formData,
                ...response.data,
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        // Check if a file was selected
        if (file) {
            // Update the formData state by setting the author_profile_pic to the selected file
            setFormData({
                ...formData,
                image: file,
            });
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await thirdparty.post(`/banner_update/${props.match.params.id}`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.status === 200) {
                toast.success("Banner Added Successfully!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000,
                });
            }
            console.log("Form data sent:", response.status);
        } catch (error) {
            console.error("Error submitting form:", error);
            // Handle errors, show error messages, etc.
        }
    };

    useEffect(() => {
        fetchData();
    }, []);
    return (
        <div className="fixed-left">
            <SEO
                title="Update Banner"
                description="Update Banner United Hospital"
                pathSlug="/Banner_create"
                keywords="Update Banner, Banner"
            />
            <div id="wrapper">
                <Route component={LeftSidebar} />
                <div className="content-page">
                    <div className="content">
                        <Route component={TopHeader} />
                        <div className="page-content-wrapper d-flex justify-content-center">
                            <div className="col-lg-6">
                                <div className="card m-b-20">
                                    <div className="card-body">
                                        <h2 className="mt-0">Update Banner</h2>
                                        <hr />
                                        <form
                                            id="adddepartmentform"
                                            className="needs-validation"
                                            noValidate
                                            onSubmit={handleSubmit}
                                        >
                                            <div className="row">
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label>Serial No.</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="index_no"
                                                            id="index_no"
                                                            value={formData.index_no}
                                                            onChange={handleChange}
                                                            required
                                                            placeholder="Serial Number"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-8">
                                                    <div className="form-group">
                                                        <label>Title</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="title"
                                                            id="title"
                                                            value={formData.title}
                                                            onChange={handleChange}
                                                            required
                                                            placeholder="Name"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-group">
                                                        <label>Description</label>
                                                        <textarea
                                                            // type="text"
                                                            className="form-control"
                                                            name="description"
                                                            id="description"
                                                            value={formData.description}
                                                            onChange={handleChange}
                                                            // required
                                                            placeholder="Description"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-group">
                                                        <label>Banner Image</label>
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            name="image"
                                                            id="image"
                                                            onChange={handleFileChange}
                                                            accept="image/*" // Specify the accepted file types if needed
                                                            placeholder="Banner Image"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-group text-right">
                                                <button
                                                    type="submit"
                                                    className="btn waves-effect waves-light"
                                                >
                                                    Update
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer autoClose={5000} />
        </div>
    );
};

export default Banner_create;



// WEBPACK FOOTER //
// ./src/component/admin/Banner_update.js